import { createFileRoute } from "@tanstack/react-router";

import { MaskRedirect } from "@/features/shared/route-masking";

export const Route = createFileRoute("/office/tasks/create")({
  component: () => (
    <MaskRedirect
      to="/office/tasks"
      action="create-task"
      mask="/office/tasks/create"
    />
  ),
});
